import {Injectable} from '@angular/core';
import {Mutation, gql} from 'apollo-angular';
import { IPortalEvent } from '@collections/portal-events/interfaces/portal-events.interface';

export interface ISoftDeletePortalEventResponse {
  softDeletePortalEvent: IPortalEvent;
}

@Injectable()
export class SoftDeletePortalEventGQL extends Mutation<ISoftDeletePortalEventResponse> {
  document = gql`
    mutation softDeletePortalEvent( $id: ObjectId!) {
      softDeletePortalEvent( id: $id) {
        _id
        deleted
      }
    }
  `;
}

export interface IRestoreDeletedPortalEventResponse {
  restoreDeletedPortalEvent: IPortalEvent;
}

@Injectable()
export class RestoreDeletedPortalEventGQL extends Mutation<IRestoreDeletedPortalEventResponse> {
  document = gql`
    mutation restoreDeletedPortalEvent($id: ObjectId!) {
      restoreDeletedPortalEvent(id: $id) {
        _id
        deleted
      }
    }
  `;
}

export interface IHardDeletePortalEventResponse {
  hardDeletePortalEvent: IPortalEvent;
}

@Injectable()
export class HardDeletePortalEventGQL extends Mutation<IHardDeletePortalEventResponse> {
  document = gql`
    mutation hardDeletePortalEvent($id: ObjectId!) {
      hardDeletePortalEvent(id: $id) {
        _id
      }
    }
  `;
}
